module.exports = __webpack_public_path__ + "img/warning.dc87bdd4.svg";